// extracted by mini-css-extract-plugin
export default {"nextButtonWrapper":"Ml8GK2"};